import React from "react";
import {
  Div,
  Paper,
  H6,
  Text,
  Image,
} from "qdm-component-library";
import "./style.css";
import { withAllContexts } from "../../../HOCs";
import { AlertProps, checkMaxDateValidation } from "../../../utils";
import ShowList from "./showList";
import PatientQualification from "./addAddress_q";
import moment from "moment";
class Qualification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Showfilter: this.props?.[this.props.saveto]?.names,
      limited: false,
      Collapse: false,
      addCollapseForm: false,
      contact: [{}]
    };
  }

  styles = {
    labelStyle: {
      color: "#6F6F6F",
      fontSize: "12px",
      marginBottom: "6px",
      fontFamily: `pc_regular !important`,
    },
    borderStyle: {
      borderRadius: 8,
      borderColor: "#E0E0E0",
    },
    containedButton: {
      backgroundColor: "#0071F2",
      borderColor: "#0071F2",
      borderRadius: 8,
      padding: "8px 15px",
      minWidth: 100,
      fontSize: 14,
      fontFamily: "pc_medium !important",
    },
  };
  onChangeState = (key, value, limit) => {
    if (limit) {
      if (limit < value.length) {
        return false;
      }
    }
    this.setState({
      ...this.state,
      [key]: value,
    });
  };

  validateCheck = (data) => {
    if (data?.start_date?.length > 0 && data?.end_date?.length > 0) {
      if (checkMaxDateValidation(data?.start_date, data?.end_date)) {
        return true
      }
      if (data?.issued_by?.length > 0 && checkMaxDateValidation(data?.end_date, data?.issued_by)) {
        return true
      }
    }

    if (data?.name?.length > 0 && data?.qualification_name?.length > 0) {
      return false
    } else {
      let errors = {
        name: data?.name?.length > 0 ? false : true,
        qualification_name: data?.qualification_name?.length > 0 ? false : true
      }
      this.setState({ ...this.state, erorr: errors });
      return true
    }
  }

  saveAddress = (data) => {

    // end_date: "2021-08-16"
    // issued_by: "2021-08-17"
    // name: "sdfghjkl"
    // qualification_name: "xcvjkl"
    // start_date: "2021-08-15"
    // use: null
    if (this.validateCheck(data)) {
      this.props.alert.setSnack({
        open: true,
        severity: AlertProps.severity.error,
        msg: "Please fill mandatory fields",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.right,
      })
      return false;
    }
    let patientData = this.props[this.props.saveto];
    if (this.state?.editindex !== null) {
      patientData.qualification[this.state?.editindex] = data;
    } else {
      patientData.qualification.push(data);
    }
    patientData[this.props.setTo]({
      ...patientData,
    });


    this.Clear();
  };

  Clear = () => {
    this.setState({
      select_role: null,
      speciality: null,
      select_entity: null,
      entity_name: null,
      select_location: null,
      start_date: null,
      end_date: null,
      addCollapseForm: false,
      contact: [{}]
    });
  };

  FlterOptions = (type) => {
    const { allMasters } = this.props;
    var lista = [];
    const data = allMasters?.[type];
    for (let index in data) {
      var datatemp = {
        value: data[index]?.coding?.display,
      };
      lista.push(datatemp);
    }
    return lista;
  };
  OpenAddress = async (e) => {
    this.setState({
      addAddress: e?.currentTarget ?? null,
    });
  };
  handleClear = () => {
    this.setState({
      editadd: {},
      editindex: null,
      addCollapseForm: false
    });
  };

  Collapse(e) {
    this.setState({
      Collapse: !this.state.Collapse,
    });
  }

  addCollapse(e) {
    this.setState({
      addCollapseForm: !this.state.addCollapseForm,
      Collapse: true,
    });
  }

  onedit = async (v, i, e) => {

    this.setState({
      ...this.state,
      ...v,
      editadd: { ...v },
      editindex: i
    });
    this.addCollapse(e);
  };

  ondelete = (v, i) => {
    let patientData = this.props[this.props.saveto];
    patientData.qualification.splice(i, 1);
    patientData[this.props.setTo]({
      ...patientData,
    });
    this.Clear();
  };

  setCustomContact = (name, value, index) => {
     if (name === "mode") {
       this.state.contact[index]["mobile"] = "";
     }
    

    this.state.contact[index][name] = value;
    this.setState({
      ...this.state,
    })
  }

  addNewContact = () => {
    this.state.contact.push({});
    this.setState({
      ...this.state,
    })
  }

  deleteContect = (index) => {
    let contact = this.state.contact.splice(0, index)
    this.setState({
      ...this.state,
      contact: contact
    })
  }

  render() {
    let { addCollapseForm, Collapse } = this.state;
    const { qualification } = this.props[this.props.saveto];
    const { parent_id } = this.props;

    return (
      <Div
        id={`${parent_id}-parent-div`}
        className="pi-root">
        <Paper
          id={`${parent_id}-parent-paper`}
          className="pi-paper">
          <Div
            id={`${parent_id}-title-div`}
            style={{ display: "flex", alignItems: "center" }}>
            <H6
              id={`${parent_id}-title-h6`}
              className="pi-title"
              style={{
                display: "flex",
                alignItems: "center",
                margin: 0,
                flex: 1,
              }}
            >
              Qualification
              {qualification?.length > 0 && (<>
                {" (" + JSON.stringify(qualification?.length) + ")"}
                <Image
                  id={`${parent_id}-tick-image`}
                  style={{ width: 16, height: 16, marginLeft: 5 }}
                  src="images/icons8-ok.svg"
                  alt="tick"
                /></>
              )}
              {/* )} */}
            </H6>
            <Text
              id={`${parent_id}-Add-New-text`}
              inLineStyles={{
                color: "#0071F2",
                fontSize: 12,
                display: "flex",
                alignItems: "center",
              }}
              className="pi-addbtn"
            >{addCollapseForm ?
              <Text
                id={`${parent_id}-addCollapseForm-Add-New-text`}
                className="pi-addbtn"
                style={{ marginRight: 10, color: "gray" }}
              >
                + Add New
              </Text> :
              <Text
                id={`${parent_id}-addCollapse-Add-New-text`}
                className="pi-addbtn"
                style={{ marginRight: 10 }}
                onClick={(e) => {
                  this.handleClear();
                  this.addCollapse(e);
                }}
              >
                + Add New
              </Text>}
              {qualification?.length > 0 && (
                <React.Fragment>
                  {Collapse ? (
                    <Image
                      id={`${parent_id}-downArrow-image`}
                      src="images/Group 3873.svg"
                      style={{ width: 20, height: 20 }}
                      alt="downArrow"
                      onClick={(e) => this.Collapse(e)}
                    />
                  ) : (
                    <>
                      <Image
                        id={`${parent_id}-upArrow-image`}
                        style={{ width: 20, height: 20 }}
                        src="images/Group -1.svg"
                        alt="upArrow"
                        onClick={(e) => this.Collapse(e)}
                      />
                    </>
                  )}
                </React.Fragment>
              )}
            </Text>
          </Div>
          {(Collapse && qualification?.length > 0) && (
            <Div
              id={`${parent_id}-ShowList-div`}
              style={{ paddingTop: "10px" }} >
              {qualification?.map((val, i) => {
                return (
                  <div
                    id={`${parent_id}-${i}-ShowList-div`}
                    style={{ marginBottom: 12 }}>
                    <ShowList
                      parent_id={'qulification' + i}
                      index={i + 1}
                      title={val?.name ?? ""}
                      description={
                        (val?.qualification_name?.length > 0 ? val?.qualification_name : "") +
                        (val.start_date?.length > 0 ? ", " + moment(val.start_date).format("Do' MMM YYYY") : "") +
                        (val.end_date?.length > 0 ? ", " + moment(val.end_date).format("Do' MMM YYYY") : "") +
                        (val.issued_by?.length > 0 ? ", " + moment(val.issued_by).format("Do' MMM YYYY") : "")
                      }
                      ondelete={() => this.ondelete(val, i)}
                      onedit={(e) => this.onedit(val, i, e)}
                      onswitch={false}
                    />
                  </div>
                );
              })}
            </Div>
          )}

          {addCollapseForm && (
            <Div
              id={`${parent_id}-PatientQualification-div`}
            >
              <Paper
                id={`${parent_id}-PatientQualification-paper`}
                style={{ margin: 0, marginTop: 10 }}>
                <PatientQualification
                  parent_id={'Qualification'}
                  saveAddress={this.saveAddress}
                  allMasters={this.props?.allMasters}
                  handleClear={this.handleClear}
                  index={this.state.editindex}
                  editData={this.state.editadd}
                  setTo={this.props.setTo}
                  saveto={this.props.saveto}
                  onclose={() => this.OpenAddress(null)}
                />
              </Paper>
            </Div>
          )}
        </Paper>
      </Div>
    );
  }
}

export default withAllContexts(Qualification);
